import { render } from "./oficialiaFolios.vue?vue&type=template&id=f36a8e34"
import script from "./oficialiaFolios.vue?vue&type=script&lang=js"
export * from "./oficialiaFolios.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__